import { ValidationObject } from 'app/services/validation.service';
import { FormsEnum } from 'app/shared/enums';
import { ValidatorDataInterface } from 'app/shared/interfaces/ValidatorData.interface';
import { FormsConfigState } from 'app/store/data/formsConfig';

export default function validateCepikDataCompatibility(
  data: ValidatorDataInterface,
  state: FormsConfigState
): ValidationObject {
  const { formName, questionKey } = data;

  return {
    key: 'cepik_data_mismatch',
    valid:
      formName !== FormsEnum.CheckoutForm ||
      !state.mismatchedCepikDataQuestionKeys?.includes(questionKey),
  };
}
